import { oc } from '@orpc/contract';
import { listApprovalsByOwnerInputSchema, listApprovalsByOwnerOutputSchema } from '../schemas/approvals.schemas.js';
/** Every approval ever raised on one record, decided or not — the request is part of its history. */
export const listApprovalsByOwnerContract = oc
    .route({
    method: 'GET',
    path: '/approvals',
    tags: ['Approvals'],
    summary: 'List the approvals of an estimate or a stock vehicle',
})
    .input(listApprovalsByOwnerInputSchema)
    .output(listApprovalsByOwnerOutputSchema);
//# sourceMappingURL=list-approvals-by-owner.contract.js.map